module.exports = __webpack_public_path__ + "assets/widget-en-f61571c4.png";